import React, { memo, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';
import SectionList from 'components/SectionList';

import styles from './styles';
const useStyles = createUseStyles(styles, 'TabsLists');

const TabsLists = ({ list, order, setOrder, overrides }) => {
    const classes = useStyles();
    const { t } = useWeb5Context({ overrides });
    const [state] = useState({});

    const onDragEnd = useCallback(
        (event) => {
            const newOrder = [...order];
            const from = newOrder.indexOf(event.node.data.id);
            const to = event.overIndex;
            const element = newOrder.splice(from, 1)[0];

            newOrder.splice(to, 0, element);

            setOrder(newOrder);
            return Promise.resolve();
        },
        [order, setOrder],
    );

    const onRowDrag = useCallback(() => true, []);

    const columns = useMemo(
        () => [
            {
                colId: 'description',
                field: 'description',
                headerName: t('cfm_label_description'),
                cellRenderer: 'textCell',
                cellRendererParams: {
                    useTooltip: true,
                },
                rowDrag: onRowDrag,
                resizable: true,
            },
        ],
        [onRowDrag, t],
    );

    const placeholderOptions = useMemo(() => ({ avatars: false }), []);

    return (
        <SectionList
            id="tabs-list"
            className={classes.root}
            columns={columns}
            rows={list}
            isLoading={state.isLoading}
            hasError={state.hasError}
            headerHeight={40}
            rowHeight={40}
            onDragEnd={onDragEnd}
            useDragRows
            useLoaderPlaceholder
            placeholderOptions={placeholderOptions}
        />
    );
};

TabsLists.propTypes = {
    list: PropTypes.array,
    order: PropTypes.array,
    setOrder: PropTypes.func,
};

export default memo(TabsLists);
